<style scoped>

  .ui.main.container {
    min-height: 100vh;
    width: 95%;
    padding-top: 75px;
  }

  .ui.menu .item img.logo {
    margin-right: 15px;
    height: 12px;
    width: 70px;
  }

  .menu-icon {
    margin-left: 8px !important;
  }

  .wireframe {
    margin-top: 2em;
  }

  .ui.footer.segment {
    margin: 5em 0em 0em;
    padding: 5em 0em;
  }

</style>

<template>

  <div v-show="!loading" class="app-main-container app-bg  animated fadeIn">

    <top-menu @onLogout="showLogoutDialog()" />
    <side-menu @onLogout="showLogoutDialog()" />

    <div class="ui main container" @click="onContainerClick()">
      <transition appear enter-active-class="animated fadeIn" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>

    <div class="ui inverted vertical footer segment">
      <div class="ui container">
        <p>{{ appName }}</p>
        <p>© {{ new Date().getFullYear() }} - IFC Cobrecom. Todos os direitos reservados.</p>
        <p>Desenvolvido por <a class="clickable" @click="openNewTab('http://vhtecnologia.com')" style="color: #21ABA8;">vhtecnologia</a></p>
      </div>
    </div>

    <div id="logout-dialog" class="ui tiny modal logout-modal">
      <div class="ui header">
        Logout
      </div>
      <div class="content">
        <p>Deseja realmente sair ?</p>
      </div>
      <div class="actions">
        <button class="ui cancel basic button">
          <i class="remove icon"></i>
          Não
        </button>
        <button class="ui red basic button" :class="{ loading: logginOut }" @click="onConfirmLogout()">
          <i class="checkmark icon"></i>
          Sim
        </button>
      </div>
    </div>

  </div>

</template>

<script>

  import config from "../../config.json"
  import packageJson from "../../package.json"
  import { SideMenu, TopMenu } from "@/components"
  import { AuthService, AppLocalStorage } from "@/services"
  import { AppBrowser, Loader, Message } from "@/utils"

  export default {

    data() {
      return {
        loading: true,
        logginOut: false,
      }
    },

    components: {
      SideMenu,
      TopMenu,
    },

    computed: {

      appName() {
        return config.server.name + " v" + packageJson.version
      },
    },

    mounted() {      
      this.checkToken()
    },

    beforeDestroy() {
      $(".logout-modal").remove()
    },

    methods: {

      async checkToken() {

        if (this.$store.state.loggingIn) {
          this.loading = false
          this.$store.commit("setLoggingIn", false)
          return  
        }

        Loader.show("Carregando...")

        this.loading = true        

        try {

          await AuthService.checkToken()

          Loader.hide()

          this.loading = false
          
        } catch (error) {
          
          this.$errorHandler(error)
        }
      },

      onContainerClick() {

        // Just to hide dropdowns on mobile
      },

      navTo(route) {

        $("#sidebar").sidebar("hide")

        this.$router.push(route)
      },

      showLogoutDialog() {

        $("#sidebar").sidebar("hide")

        $("#logout-dialog").modal("show")
      },

      openNewTab(url) {
        AppBrowser.openNewTab(url)
      },

      async onConfirmLogout() {

        if (this.logginOut)
          return

        this.logginOut = true

        try {

          await AuthService.logout()

          AppLocalStorage.clear()

          location.reload()
          
        } catch (error) {

          this.$errorHandler(error)

          setTimeout(() => {
            AppLocalStorage.clear()
            location.reload()      
          }, 2000)            
        }        
      },      
    },
  }

</script>
